import React, { Component } from 'react';
import { Row, Col, Card, CardBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import "react-datepicker/dist/react-datepicker.css";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";



class PackageCost extends Component {
    constructor(props) {
      super(props);
      console.log(this.props.data,"dsfasdfasdfahsdfhjsdkhfkujhsfjhk")

      this.state = {
        itinerary : this.props.data,
        hotel_tds : this.props.data.hotel_tds,
        vehicle_tds : this.props.data.vehicle_tds,
        activity_tds : this.props.data.activity_tds,
        hotel_margin : this.props.data.hotel_margin,
        vehicle_margin : this.props.data.vehicle_margin,
        activity_margin : this.props.data.activity_margin,
        hotel_discount: this.props.data.hotel_discount,
        vehicle_discount: this.props.data.vehicle_discount,
        activity_discount: this.props.data.activity_discount,
        pkg_cost : this.props.data.pkg_const_margin,
        subtotal: this.props.data.sub_total,
        margin_amnt: this.props.data.margin_amount,
        tds_amnt: this.props.data.tds_amount,
        discount_amount: this.props.data.discount_amount,
        is_load : false,
      }

      toastr.options = {
        positionClass: "toast-top-right",
        closeButton: "false",
        progressBar: "true",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
        showDuration: 300,
        hideDuration: 1000,
        timeOut: 5000,
        extendedTimeOut: 1000
      }
      this.calculatePkgCost = this.calculatePkgCost.bind(this)
        
    }  

    componentDidCatch(error) {
        console.log(error)
    }

    componentDidUpdate(prevProps) {
      const {hotel_margin, hotel_tds, vehicle_margin, vehicle_tds, activity_margin, activity_tds, hotel_discount, vehicle_discount, activity_discount} = this.state
        if (prevProps.hotel_total !== this.props.hotel_total || prevProps.vehicle_total !== this.props.vehicle_total || prevProps.activity_total !== this.props.activity_total){
          this.calculatePkgCost(hotel_tds, vehicle_tds, activity_tds,hotel_margin, vehicle_margin, activity_margin, hotel_discount,
                                vehicle_discount, activity_discount, this.props.is_load)
        }
      }

    componentDidMount(){
    }

    calculatePkgCost( hotel_tds, vehicle_tds, activity_tds,hotel_margin, vehicle_margin,
                      activity_margin, hotel_discount, vehicle_discount, activity_discount, Change_state){
      const { activity_total, hotel_total,vehicle_total } = this.props
      let subtotal = parseInt(activity_total)+parseInt(hotel_total)+parseInt(vehicle_total)
      let hotel_tds_amnt = (parseFloat(hotel_total)*parseFloat(hotel_tds))/100
      let vehicle_tds_amnt = (parseFloat(vehicle_total)*parseFloat(vehicle_tds))/100
      let activity_tds_amnt = (parseFloat(activity_total)*parseFloat(activity_tds))/100
      let hotel_margin_amnt = (parseFloat(hotel_total)*parseFloat(hotel_margin))/100
      let vehicle_margin_amnt = (parseFloat(vehicle_total)*parseFloat(vehicle_margin))/100
      let activity_margin_amnt = (parseFloat(activity_total)*parseFloat(activity_margin))/100
      let hotel_discount_amnt = hotel_discount > 0 ? ((parseInt(hotel_total)+hotel_tds_amnt+hotel_margin_amnt)*hotel_discount)/100: hotel_discount
      let vehicle_discount_amnt = vehicle_discount > 0 ? ((parseInt(vehicle_total)+vehicle_tds_amnt+vehicle_margin_amnt)*vehicle_discount)/100: vehicle_discount
      let activity_discount_amnt = activity_discount > 0 ? ((parseInt(activity_total)+activity_tds_amnt+activity_margin_amnt)*activity_discount)/100: activity_discount
      let tds_amnt = hotel_tds_amnt+vehicle_tds_amnt+activity_tds_amnt
      let margin_amnt = hotel_margin_amnt+vehicle_margin_amnt+activity_margin_amnt
      let discount_amount = hotel_discount_amnt+vehicle_discount_amnt+activity_discount_amnt

      let total = (subtotal+tds_amnt+margin_amnt)-discount_amount
      
      let data = {}
      data['hotel_margin'] = hotel_margin
      data['vehicle_margin'] = vehicle_margin
      data['activity_margin'] = activity_margin
      data['hotel_tds'] = hotel_tds
      data['activity_tds'] = activity_tds
      data['vehicle_tds'] = vehicle_tds
      data['hotel_discount'] = hotel_discount
      data['vehicle_discount'] = vehicle_discount
      data['activity_discount'] = activity_discount
      data['sub_total'] = parseFloat(subtotal).toFixed(2)
      data['tds_amount'] = parseFloat(tds_amnt).toFixed(2)
      data['margin_amount'] = parseFloat(margin_amnt).toFixed(2)
      data['discount_amount'] = parseFloat(discount_amount).toFixed(2)
      data['pkg_const_margin'] = parseInt(total)

      let itinerary_pkg_cost = parseInt(this.state.itinerary.pkg_const_margin)

      // if(Change_state || (itinerary_pkg_cost === 0 && parseInt(total) !== 0)){
        this.props.SaveItineraryData(data)
      // }
        
      this.setState({ 
        hotel_tds : hotel_tds,
        vehicle_tds : vehicle_tds,
        activity_tds : activity_tds,
        hotel_margin : hotel_margin,
        vehicle_margin : vehicle_margin,
        activity_margin : activity_margin,
        hotel_discount:hotel_discount,
        vehicle_discount:vehicle_discount,
        activity_discount:activity_discount,
        pkg_cost:parseFloat(total).toFixed(2),
        subtotal:parseFloat(subtotal).toFixed(2),
        tds_amnt:parseFloat(tds_amnt).toFixed(2),
        margin_amnt:parseFloat(margin_amnt).toFixed(2),
        discount_amount:parseFloat(discount_amount).toFixed(2)
      })
      
    }
    
    handleTotalDetailSave(row,oldValue, newValue){
      const { hotel_tds, vehicle_tds, activity_tds, hotel_margin, activity_margin, vehicle_margin,
              hotel_discount, vehicle_discount, activity_discount} = this.state
      let Change_state = true 
      if(parseInt(oldValue) !== parseInt(newValue)){
        if(row.id === 'tds'){
          this.calculatePkgCost(row.hotel, row.vehicle, row.activity, hotel_margin,vehicle_margin ,activity_margin,
                                hotel_discount, vehicle_discount, activity_discount, Change_state )
        }else if(row.id === 'margin') {
          this.calculatePkgCost(hotel_tds,vehicle_tds, activity_tds, row.hotel, row.vehicle, row.activity, hotel_discount,
                                vehicle_discount, activity_discount, Change_state )            
        }else if(row.id === 'discount') {
          this.calculatePkgCost(  hotel_tds,vehicle_tds, activity_tds, hotel_margin, vehicle_margin ,activity_margin,
                                  row.hotel, row.vehicle, row.activity, Change_state)            
        }
      }   
    }

    render() {
        const { hotel_tds, vehicle_tds, activity_tds, hotel_margin, activity_margin, vehicle_margin, pkg_cost, hotel_discount, vehicle_discount, activity_discount } = this.state
        const { activity_total, hotel_total, vehicle_total,}  = this.props
        
        const TotalData = [
            { id: 'total', name: "Total", hotel: "₹ "+hotel_total+".00", vehicle :"₹ "+vehicle_total+".00", activity: "₹ "+activity_total+".00"  },
            { id: 'tds', name: "GST (%)", hotel: hotel_tds, vehicle :vehicle_tds, activity: activity_tds },
            { id: 'margin', name: "Margin (%)", hotel: hotel_margin, vehicle :vehicle_margin, activity: activity_margin  },
            { id: 'discount', name: "Discount (%)", hotel: hotel_discount, vehicle :vehicle_discount, activity: activity_discount  },
        
          ];

        const TotalColumns = [
          {
              dataField: "id",
              text: "id",
              hidden: true,
          },
          // {
          //   dataField: "unique",
          //   text: "id",
          //   // hidden: true,
          //   isDummyField: true,
          // },
          
          {
              dataField: "name",
              text: "Prices",
              editable: false,
              headerStyle: { backgroundColor: '#fcb92c' },
              editCellStyle: {
                width: '25%'
              },
          },
          {
              dataField: "hotel",
              text: "Hotels",
              headerStyle: { backgroundColor: '#fcb92c' },
              editable: (content, row,) => row.id !== "total",
              editCellStyle: {
                width: '25%'
              },
              formatter: (cellContent, row) => (
                row.id==='total'? row.hotel: row.hotel+" %" 
              ),
              validator: (newValue, row, column) => {
                  if (isNaN(newValue)) {
                    return {
                      valid: false,
                      message: 'Should be numeric'
                    };
                  }
                  if (newValue > 100) {
                    return {
                      valid: false,
                      message: 'Should be less than 100'
                    };
                  }
                  return true;
                }
          },
          {
              dataField: "vehicle",
              text: "Vehicles",
              headerStyle: { backgroundColor: '#fcb92c' },
              editable: (content, row,) => row.id !== "total",
              editCellStyle: {
                width: '25%'
              },
              formatter: (cellContent, row) => (
                row.id==='total'? row.vehicle: row.vehicle+" %" 
              ),
              validator: (newValue, row, column) => {
                  if (isNaN(newValue)) {
                    return {
                      valid: false,
                      message: 'Should be numeric'
                    };
                  }
                  if (newValue > 100) {
                    return {
                      valid: false,
                      message: 'Should be less than 100'
                    };
                  }
                  return true;
                }

          },
          {
              dataField: "activity",
              text: "Activities",
              editCellStyle: {
                width: '25%'
              },
              headerStyle: { backgroundColor: '#fcb92c' },
              editable: (content, row,) => row.id !== "total",
              formatter: (cellContent, row) => (
                row.id==='total'? row.activity: row.activity+" %" 
              ),
              validator: (newValue,) => {
                  if (isNaN(newValue)) {
                    return {
                      valid: false,
                      message: 'Should be numeric'
                    };
                  }
                  if (newValue > 100) {
                    return {
                      valid: false,
                      message: 'Should be less than 100'
                    };
                  }
                  return true;
                }
          },

        ];
        return (
            <React.Fragment key={"itinerary-total"}>
                <Row>
                    <Col xs={12}>
                        <Card>
                       
                              <CardBody>
                                  <div className="table-responsive">
                                  {!["tour completed"].includes(this.state.itinerary.status) && this.props.user.is_superuser?
                                  <BootstrapTable
                                      keyField={"id"}
                                      data={TotalData}
                                      columns={TotalColumns}
                                      cellEdit={ cellEditFactory({    mode: 'dbclick',
                                                                      blurToSave: true,
                                                                      afterSaveCell: (oldValue, newValue, row, column) => { this.handleTotalDetailSave(row, oldValue, newValue) }
                                                                  }) }
                                  />:
                                    <BootstrapTable
                                      keyField={"id"}
                                      // keyField="id"
                                      data={TotalData}
                                      columns={TotalColumns}
                                  />}
                                  </div>
                                  <AvForm className="needs-validation">
                                      <Row>
                                        {this.state.itinerary.packeges.map((pkg) => {
                                          return (
                                            <Col md={2}>
                                          <div className="mb-3">
                                            <AvField
                                                name={pkg}
                                                label={"Est. "+pkg+" Package Cost"}
                                                type="text"
                                                value={ pkg === "Budget"?"₹ "+this.state.itinerary.estimated_budget_cost:
                                                        pkg === "Standard"?"₹ "+this.state.itinerary.estimated_standard_cost:
                                                        pkg === "Delux"?"₹ "+this.state.itinerary.estimated_delux_cost:
                                                        pkg === "Premium"?"₹ "+this.state.itinerary.estimated_premium_cost:
                                                        "₹ "+this.state.itinerary.estimated_platinum_cost
                                                      }
                                                disabled
                                                />
                                          </div>
                                        </Col>

                                          )
                                        })}
                                        <Col md={2}>                  
                                          <div className="mb-3 form-floating">
                                            <AvField
                                                name="package_cost"
                                                label="Final Package Cost"
                                                value = {"₹ "+pkg_cost}
                                                type="text"
                                                disabled
                                                />
                                          </div>
                                        </Col> 
                                      </Row>
                                      <Row>
                                        <Col md={2}>                  
                                          <div className="mb-3 form-floating">
                                            <AvField
                                                name="package_cost"
                                                label="Sub Total"
                                                value = {"₹ "+this.state.subtotal}
                                                type="text"
                                                disabled
                                                />
                                          </div>
                                        </Col> 
                                        <Col md={2}>                  
                                          <div className="mb-3 form-floating">
                                            <AvField
                                                name="package_cost"
                                                label="GST Amount"
                                                value = {"₹ "+this.state.tds_amnt}
                                                type="text"
                                                disabled
                                                />
                                          </div>
                                        </Col> 
                                        <Col md={2}>                  
                                          <div className="mb-3 form-floating">
                                            <AvField
                                                name="package_cost"
                                                label="Margin Amount"
                                                value = {"₹ "+this.state.margin_amnt}
                                                type="text"
                                                disabled
                                                />
                                          </div>
                                        </Col> 
                                        <Col md={2}>                  
                                          <div className="mb-3 form-floating">
                                            <AvField
                                                name="package_cost"
                                                label="Total Discount"
                                                value = {"₹ "+this.state.discount_amount}
                                                type="text"
                                                disabled
                                                />
                                          </div>
                                        </Col> 
                                        
                                      </Row>
                                      
                                  </AvForm>
                              </CardBody>
                        </Card>
                    </Col>
                </Row>
            
                    
            </React.Fragment>
            
        );
    }
}

export default PackageCost;